import { CategoryTag } from '@app/@shared/models/search/cti-search.model';

export const CATEGORY_TYPES = {
  TECHNOLOGY: 'technology',
  THEME: 'theme',
  SEGMENT: 'segment',
  CONTENT: 'content',
  APPLICATION: 'application',
  PURPOSE: 'purpose',
  COVERAGE_AREA: 'coverage_area'
} as const;

export enum SUBTYPE {
  SECTIONED = "Sectioned",
  NON_SECTIONED = "NonSectioned"
}

export interface ContentHeaderBlock {
  id: string;
  title: string;
  subTitle: string;
  summary: string;
  authors: Author[];
  customerSegment: string[];
  technologyVertical: string;
  themes: string[];
  featuredImage: FeaturedImage;
  categoryTags: CategoryTag[];
  contentType: string;
}

export interface Image {
  url: string;
  caption: string;
  fileName: string;
  sourceUrl: string;
}

export interface HygraphImage extends Image {
  type: 'hygraph';
}

export interface PlatformImage extends Image {
  type: 'platform';
}

export type SectionContent =
  SectionContentImage | SectionContentTable | SectionContentText | SectionContentVisualization;

export interface Section {
  title: string;
  subTitle: string;
  complimentaryContent: boolean;
  publicContent: boolean;
  expanded?: boolean;
  sectionContent: SectionContent[];
  subsections?: Section[];
}

export interface RelatedContent {
  relatedContentType: string;
  contentLink: string;
  publishDate: string;
  title: string;
}

export interface HTMLReport {
  header: ContentHeaderBlock;
  sections: Section[];
  publishDate: Date;
  name: string;
  relatedContent: RelatedContent[];
  includeTableOfContent: boolean;
  includeRelatedContent: boolean;
  downloadEnabled?: boolean;
  reportCode: string;
  reportTitle: string;
  entitled?: boolean;
  assetDetails?: AssetDetails[]
}

export interface AssetDetails {
  assetId: string;
  reportId: string;
  name: string;
  classification: string;
  mimeType: string;
  productCode: string;
}

export interface QuickSightVisual {
  hygraphId: string;
  quickSightVisualHygraphId: string;
  embedURL: string;
}

export interface HygraphVisualization {
  id: string;
  title: string;
  subtitle?: string;
  description: string;
  embedUrl: string;
}

interface Author {
  name: string;
}

interface FeaturedImage {
  url: string;
}



interface HygraphTable {
  html: string;
}

interface HygraphText {
  html: string;
}

interface SectionContentImage {
  id: string;
  image?: Image[];
}

interface SectionContentTable {
  id: string;
  caption: string;
  table?: HygraphTable[];
}

interface SectionContentText {
  id: string;
  body?: HygraphText[];
}

interface SectionContentVisualization {
  id: string;
  visualizations?: HygraphVisualization[];
}
